import { useGetAccountStates } from "@/api/account-state/account-state"
import { activeSwitchStates } from "@/constants/switchStates"
import { useGetAccountId } from "@/lib/useGetAccountId"
import { computed, ref } from "vue"

const hasCancelledSwitch = ref(false)

export const resetSwitchProgress = () => {
  hasCancelledSwitch.value = false
}

export const useSwitchProgress = () => {
  const customerQuery = useGetAccountId()
  const accountStatesQuery = useGetAccountStates(customerQuery.accountId)

  const shouldShow = computed(() => {
    if (hasCancelledSwitch.value) return false

    const supplyState = accountStatesQuery.data.value?.supply
    return supplyState && activeSwitchStates.has(supplyState)
  })

  return {
    hasCancelledSwitch,
    isSwitchInProgress: shouldShow,
  }
}
